// Mock data for Files Hub

export const mockUsers = {
  currentUser: {
    id: 1,
    github_id: 12345,
    username: 'johndoe',
    name: 'John Doe',
    email: 'john@example.com',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=John',
    is_approved: true,
    is_admin: true
  },
  pendingUser: {
    id: 2,
    github_id: 67890,
    username: 'janedoe',
    name: 'Jane Doe',
    email: 'jane@example.com',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Jane',
    is_approved: false,
    is_admin: false
  }
};

export const mockDirectories = [
  { id: 'dir-1', name: 'Images', type: 'auto', icon: 'image', fileCount: 8 },
  { id: 'dir-2', name: 'Documents', type: 'auto', icon: 'file-text', fileCount: 5 },
  { id: 'dir-3', name: 'PDFs', type: 'auto', icon: 'file', fileCount: 3 },
  { id: 'dir-4', name: 'Work Projects', type: 'custom', icon: 'folder', fileCount: 12 },
  { id: 'dir-5', name: 'Personal', type: 'custom', icon: 'folder', fileCount: 6 }
];

export const mockFiles = [
  {
    id: 'file-1',
    name: 'landscape.jpg',
    size: 1024000,
    contentType: 'image/jpeg',
    isPublic: true,
    directoryId: 'dir-1',
    uploadedBy: 'johndoe',
    uploadedAt: '2025-01-15T10:30:00Z',
    expiresAt: null,
    autoDeleteIn: 'never',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400'
  },
  {
    id: 'file-2',
    name: 'report.pdf',
    size: 5120000,
    contentType: 'application/pdf',
    isPublic: false,
    directoryId: 'dir-3',
    uploadedBy: 'johndoe',
    uploadedAt: '2025-01-14T14:20:00Z',
    expiresAt: '2025-02-14T14:20:00Z',
    autoDeleteIn: '30 days',
    url: null
  },
  {
    id: 'file-3',
    name: 'presentation.pptx',
    size: 8192000,
    contentType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    isPublic: true,
    directoryId: 'dir-2',
    uploadedBy: 'johndoe',
    uploadedAt: '2025-01-13T09:15:00Z',
    expiresAt: '2025-01-20T09:15:00Z',
    autoDeleteIn: '7 days',
    url: null
  },
  {
    id: 'file-4',
    name: 'beach.png',
    size: 921600,
    contentType: 'image/png',
    isPublic: true,
    directoryId: 'dir-1',
    uploadedBy: 'johndoe',
    uploadedAt: '2025-01-12T16:45:00Z',
    expiresAt: null,
    autoDeleteIn: 'never',
    url: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400'
  },
  {
    id: 'file-5',
    name: 'contract.docx',
    size: 2048000,
    contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    isPublic: false,
    directoryId: 'dir-2',
    uploadedBy: 'johndoe',
    uploadedAt: '2025-01-11T11:00:00Z',
    expiresAt: '2025-03-11T11:00:00Z',
    autoDeleteIn: '60 days',
    url: null
  },
  {
    id: 'file-6',
    name: 'logo.svg',
    size: 51200,
    contentType: 'image/svg+xml',
    isPublic: true,
    directoryId: 'dir-1',
    uploadedBy: 'johndoe',
    uploadedAt: '2025-01-10T08:30:00Z',
    expiresAt: null,
    autoDeleteIn: 'never',
    url: 'https://api.dicebear.com/7.x/shapes/svg?seed=logo'
  },
  {
    id: 'file-7',
    name: 'financial-report.xlsx',
    size: 4096000,
    contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    isPublic: false,
    directoryId: 'dir-4',
    uploadedBy: 'johndoe',
    uploadedAt: '2025-01-09T13:20:00Z',
    expiresAt: '2025-01-16T13:20:00Z',
    autoDeleteIn: '7 days',
    url: null
  },
  {
    id: 'file-8',
    name: 'meeting-notes.pdf',
    size: 1536000,
    contentType: 'application/pdf',
    isPublic: true,
    directoryId: 'dir-3',
    uploadedBy: 'johndoe',
    uploadedAt: '2025-01-08T15:45:00Z',
    expiresAt: null,
    autoDeleteIn: 'never',
    url: null
  }
];

export const mockPendingUsers = [
  {
    id: 3,
    github_id: 11111,
    username: 'alice_dev',
    name: 'Alice Johnson',
    email: 'alice@example.com',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Alice',
    is_approved: false,
    created_at: '2025-01-14T10:00:00Z'
  },
  {
    id: 4,
    github_id: 22222,
    username: 'bob_smith',
    name: 'Bob Smith',
    email: 'bob@example.com',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Bob',
    is_approved: false,
    created_at: '2025-01-13T14:30:00Z'
  }
];

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

export const getFileIcon = (contentType) => {
  if (contentType.startsWith('image/')) return 'image';
  if (contentType === 'application/pdf') return 'file-text';
  if (contentType.includes('word') || contentType === 'application/msword' || contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return 'file-text';
  if (
    contentType.includes('excel') ||
    contentType.includes('spreadsheet') ||
    contentType === 'application/vnd.ms-excel' ||
    contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    contentType === 'text/csv'
  ) return 'sheet';
  if (contentType.includes('presentation') || contentType.includes('powerpoint')) return 'presentation';
  if (contentType === 'text/plain') return 'file-text';
  return 'file';
};

export const getFileCategory = (contentType) => {
  if (contentType.startsWith('image/')) return 'dir-1'; // Images
  if (contentType === 'application/pdf') return 'dir-3'; // PDFs
  if (
    contentType.includes('word') ||
    contentType === 'application/msword' ||
    contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    contentType.includes('excel') ||
    contentType.includes('spreadsheet') ||
    contentType === 'application/vnd.ms-excel' ||
    contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    contentType === 'text/csv' ||
    contentType === 'text/plain' ||
    contentType.includes('presentation') ||
    contentType.includes('powerpoint')
  ) {
    return 'dir-2'; // Documents
  }
  return 'dir-4'; // Default to Work Projects
};
